import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.js';
import { PropsWithChildren } from 'react';
import { MainContent } from '../main-content/main-content.tsx';
import { useSidebarContext } from '../sidebar/sidebar-context.tsx';
import { useIsTerminalRoute } from '../use-is-terminal-route.ts';
import { shellRoot } from './app-shell-v2.css.ts';
import { MobileNavV2 } from './mobile-nav-v2.tsx';
import { SidebarV2 } from './sidebar-v2.tsx';

const AppShellV2 = ({ children }: PropsWithChildren) => {
  const isTablet = useIsTablet();
  const { isCollapsed } = useSidebarContext();
  const isTerminal = useIsTerminalRoute();

  return (
    <div
      className={shellRoot}
      data-collapsed={(isCollapsed && !isTerminal) || undefined}
      data-sidebar-hidden={isTerminal || undefined}
      data-testid="app-shell-v2"
    >
      {isTerminal ? null : isTablet ? <SidebarV2 /> : <MobileNavV2 />}
      <MainContent />
      {children}
    </div>
  );
};

export default AppShellV2;
